import { gsap } from "gsap";
import { Splide } from "@splidejs/splide";

import * as Website from '../../../Config/Website.js';

const params = {
  complete: false,
}

const instance = {
  animation: null,
  slider: null,
}

const init = () => {
  const bgElms = document.getElementsByClassName('js-background');
  const fvElm = document.getElementById('js-fv');

  const sliderElm = fvElm.querySelector('.js-slider');
  const strokeElm = fvElm.querySelector('.js-stroke');
  const frameElm = fvElm.querySelector('.js-frame');
  const marqueeElm = fvElm.querySelector('.js-marquee');

  const copyElm = fvElm.querySelector('.js-copy');


  // background animation init
  for(const bgElm of bgElms) {
    const index = Array.from(bgElms).indexOf(bgElm);
    if(Website.status.winWidth > Website.status.winHeight) {
      if(index % 2 === 0) {
        gsap.set(bgElm, { 
          clipPath: 'inset(100% 0% 0% 0%)'
        });
      } else {
        gsap.set(bgElm, { 
          clipPath: 'inset(0% 0% 100% 0%)'
        });
      }
    } else {

      if(index % 2 === 0) {
        gsap.set(bgElm, { 
          clipPath: 'inset(0% 100% 0% 0%)'
        });
      } else {
        gsap.set(bgElm, { 
          clipPath: 'inset(0% 0% 0% 100%)'
        });
      }
    }
  }

  // stroke and frame animation init
  gsap.set(strokeElm, {
    visibility: 'hidden',
    scaleX: 0,    
  });

  gsap.set(frameElm, {
    visibility: 'hidden',
    scaleX: 0,    
  });

  // marquee animation init
  gsap.set(marqueeElm, {
    opacity: 0,
  });

  // copy animation init 
  gsap.set(copyElm, {
    clipPath: 'inset(0% 100% 0% 0%)',
    visibility: 'hidden',
  })

  // slider init
  gsap.set(sliderElm, {
    opacity: 0,
    scale: 0.85,
    transformOrigin: 'center bottom',
  });

  const speed = 500;
  instance.slider = new Splide(sliderElm, {
    type: 'fade',
    pagination: false,
    arrows: false,
    speed: speed,
    interval: 4000,
    autoplay: 'pause',
    rewind: true,
    rewindSpeed: speed,
    pauseOnFocus: false,
    pauseOnHover: false,
    drag: false,
    reducedMotion: {
      speed: speed,
      rewindSpeed: speed,
      autoplay: 'pause',
    },
  });
  
  instance.slider.on('mounted', () => {
    const firstSlide = instance.slider.Components.Slides.getAt(0);
    const allSlides = instance.slider.Components.Slides.get();
    allSlides.filter(slide => slide !== firstSlide).forEach(slide => {
      gsap.set(slide.slide.querySelector('.js-eyecatch'), {
        scale: 0.85,
      });
    });
  });
  instance.slider.on('moved', (next, prev) => {
    const nextSlide = instance.slider.Components.Slides.getAt(next).slide;
    const prevSlide = instance.slider.Components.Slides.getAt(prev).slide;
    gsap.set(prevSlide.querySelector('.js-eyecatch'), {
      scale: 0.85,
    });
    gsap.to(nextSlide.querySelector('.js-eyecatch'), {
      scale: 1,
      duration: 0.5,
      ease: 'back.out',
    });
  });

  instance.slider.mount();
}


const load = () => {
  const bgElms = document.getElementsByClassName('js-background');
  const fvElm = document.getElementById('js-fv');

  const sliderElm = fvElm.querySelector('.js-slider');
  const strokeElm = fvElm.querySelector('.js-stroke');
  const frameElm = fvElm.querySelector('.js-frame');
  const marqueeElm = fvElm.querySelector('.js-marquee');

  const copyElm = fvElm.querySelector('.js-copy');


  instance.animation = gsap.timeline({
    onComplete: () => {
      params.complete = true;
    }
  });

  const speed = {
    start: {
      duration: 0.5,
      delay: 0.5,
    },
    phase01: {
      duration: 0.5,
      delay: 0,
    },
    phase02: {
      duration: 0.5,
      delay: 0,
    },
    end: {
      duration: 0.5,
      delay: 0,
    }
  }

  let current = 0;
  const process = Object.keys(speed);
  for(const key in speed) {
    instance.animation.addLabel(key, current);
    const { duration, delay } = speed[key];
    current += duration + delay;
  }
  // background animation
  instance.animation.to(bgElms, {
    clipPath: 'inset(0% 0% 0% 0%)',
    duration: speed[process[0]].duration,
    delay: speed[process[0]].duration,
    ease: 'power2.inOut',
    onComplete: () => {
      fvElm.classList.add(Website.classList.actView);
    }
  }, process[0]);

  // stroke and frame animation
  instance.animation.to(strokeElm, {
    scaleX: 1,
    visibility: 'visible',
    duration: speed[process[1]].duration,
    delay: speed[process[1]].delay,
    ease: 'power4.inOut',
  }, process[1]);
  
  instance.animation.to(frameElm, {
    scaleX: 1,
    visibility: 'visible',
    duration: speed[process[1]].duration,
    delay: speed[process[1]].delay,
    ease: 'power4.inOut',
  }, process[1]);

  // marquee and slider animation
  instance.animation.to(sliderElm, {
    opacity: 1,
    scale: 1,
    duration: speed[process[2]].duration,
    delay: speed[process[2]].delay,
    ease: 'back.out',
    onComplete: () => {
      instance.slider.Components.Autoplay.play();
    }
  }, process[2]);

  instance.animation.to(marqueeElm, {
    opacity: 1,
    duration: speed[process[2]].duration,
    delay: speed[process[2]].delay,
    ease: 'power2.inOut',
  }, process[2]);

  // copy animation
  instance.animation.to(copyElm, {
    clipPath: 'inset(0% 0% 0% 0%)',
    visibility: 'visible',
    duration: speed[process[2]].duration,
    delay: speed[process[2]].delay,
    ease: 'power4.inOut',
  }, process[2]);
}

const check = () => {
  const fvElm = document.getElementById('js-fv');
  const mainElm = document.getElementById('js-main');

  if(mainElm.getBoundingClientRect().top < 0) {
    fvElm.classList.add(Website.classList.inact);
  }
  else {
    fvElm.classList.remove(Website.classList.inact);
  }
}

export {
  init,
  load,
  check,
  params
}